import React from 'react';
import DashboardGamesPage from '../features/games/list/pages/DashboardGamesPage';

const DashboardGames: React.FC = () => <DashboardGamesPage />;

export default DashboardGames;
